import React, { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import moment from 'moment';

import { isReadOnly } from '../utils/readOnly';
import Spinner from '../components/Spinner';
import PackagePage from '../components/Package';
import ErrorPage from '../errors/ErrorPage';
import {
  setError,
  saveAndNotify,
  clonePackage,
  deletePackage,
  pushPackagesAndNotify
} from '../actions/packageActions';

import { getOrder, pushPlacementsAndUpdateOrder } from '../actions/orderActions';
import { getConstants } from '../actions/constantActions';
import { TrackingCtx  } from "../tracking";
import { toast } from "react-toastify";
// import {selectedPlacements} from "../reducers/placementReducer";


export class Package extends Component {

  constructor(props) {
    super(props);
    const pkgId = parseInt(props.match.params.pid, 10);
    this.state = {
      dfpViewOpen: false,
      showReopenModal: false,
      itemRemainder: 0,
      itemLimit: 0,
      selectedPlacements: [],
      selectedPackages: [],
      pkgId: pkgId,
      dialog: {
        open: false,
        title: '',
        message: ''
      },
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {
      dispatch,
      match,
      constants,
      order,
      location,
      history
    } = this.props;
    const orderId = parseInt(match.params.id, 10);
    if (isEmpty(constants)) {
      dispatch(getConstants());
    }
    if (order && order.id === orderId) {
      this.setPackage();
    } else {
      dispatch(getOrder(orderId)).then(() => {
        if (this.props.error) {
          return;
        }
        this.setPackage();
      });
    }
    if (location.pathname.slice(-8) === '/refresh') {
      const newUrl = location.pathname.slice(0, -8) + location.search;
      history.push(newUrl);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location, history } = this.props;
    if (location.pathname.includes('refresh') || nextProps.location.pathname.includes('refresh')) {
      if (nextProps.location.pathname !== location.pathname) {
        window.location.reload(true);
      } else if (location.pathname.slice(-8) === '/refresh') {
        const newUrl = location.pathname.slice(0, -8) + location.search;
        history.push(newUrl);
      }
    }
  }

  setPackage = () => {
    const { dispatch, match } = this.props;
    const pkgId = parseInt(match.params.pid, 10);
    if (Number.isNaN(pkgId)) {
      document.title = `Package - GALILEO`;
    } else {
      const packages = this.props.order.Packages;
      const pkg = packages ? packages.find(p => p.id === pkgId) || {} : {};
      if (isEmpty(pkg)) {
        dispatch(setError({ status: 404, message: 'Not Found' }));
        document.title = `Package - GALILEO`;
        return;
      }
      document.title = `Package ${pkg.name} - GALILEO`;
      this.setState({ pack: pkg });
    }
    const { order } = this.props;
    const pkgOrder = Object.assign({}, order);
    let dateRun = 'TBD - no placements yet';
    pkgOrder.Placements = order.Placements.filter(pl => pl.packageId === pkgId);
    pkgOrder.Packages = order.Packages.filter(pkg => pkg.id === pkgId);
    if (pkgOrder.Placements.length > 0) {
      const startDate = pkgOrder.Placements.reduce((m, p) => m < p.start ? m : p.start, pkgOrder.Placements[0].start);
      const endDate = pkgOrder.Placements.reduce((m, p) => m > p.end ? m : p.end, pkgOrder.Placements[0].end);
      dateRun = `${moment(startDate).format('MM/DD/yyyy')} - ${moment(endDate).format('MM/DD/yyyy')}`;
    }
    this.setState({ pkgOrder: pkgOrder });
    this.setState({ dateRun: dateRun });
  };

  redirectToIo = () => {
    const { history, match } = this.props;
    const orderId = parseInt(match.params.id, 10);
    history.push(`/ios/${orderId}/refresh`);
  };

  //togglePushSettings = () => {
  //  this.setState(prevState => ({ pushSettings: !prevState.pushSettings }));
  //}

  savePackage = (pack) => {
    const { order, history, dispatch } = this.props;
    const impressions = this.sumImpressions(order, pack);
    let doUpdate = true;
    if (impressions > pack.contractedQuantity) {
      doUpdate = window.confirm('You are changing the goal to less than has already been delivered. Doing so could pause line items in your package. Do you want to continue?');
    }
    pack.legend = 'package screen';
    if (doUpdate) {
      dispatch(saveAndNotify(pack)).then(() => history.push(`/ios/${order.id}/refresh`));
    } else {
      history.push(`/ios/${order.id}/refresh`);
    }
  };

  sumImpressions = (order, pack) => {
    const pkgPlacements = order.Placements.filter(pl => pl.packageId === pack.id);
    let impressions = 0;
    pkgPlacements.forEach(pl => {
      pl.LineItems.forEach(li => impressions += li.amImpressions);
    });
    return impressions;
  };

  deletePackage = () => {
    const { order, history, dispatch } = this.props;
    const { pkgId } = this.state;
    dispatch(deletePackage(pkgId)).then(() => history.push(`/ios/${order.id}/refresh`));
  };

  canDelete = () => {
    const { order } = this.props;
    if (!order || !order.Placements || order.Placements.length === 0) {
      return false;
    }
    const thesePls = order.Placements.filter(pl => pl.packageId === this.state.pkgId);
    return !thesePls.some(pl => pl.LineItems[0] && !!pl.LineItems[0].adManagerLineitemId);
  };

  clone = () => {
    const { dispatch, history, order } = this.props;
    const { pkgId } = this.state;
    dispatch(clonePackage(pkgId)).then(() => history.push(`/ios/${order.id}/refresh`));
  };

  validationError = errors => {
    const list = errors.join(', ');
    const message = `These package fields have errors: ${list}`;
    toast.error(message, { theme: 'colored', toastId: message });
  };

  pushPackage = (pushSettings) => {
    const { dispatch, order } = this.props;
    const { selectedPlacements } = this.state;
    const ids = selectedPlacements.map(pl => (typeof pl === "object") ? pl.id : pl);
    const pushRules = this.getPushRules(pushSettings);
    dispatch(pushPackagesAndNotify(order.id, ids, pushRules)).then(() => {
      setInterval(() => {
        window.location.reload(true);
      }, 3 * 1000);
    })
  }

  pushPlacementsFromPackage = (pushSettings) => {
    const { dispatch, order, history } = this.props;
    const { selectedPlacements } = this.state;
    const ids = selectedPlacements.map(pl => (typeof pl === "object") ? pl.id : pl);
    const pushRules = this.getPushRules(pushSettings);
    dispatch(pushPlacementsAndUpdateOrder(order.id, ids, pushRules, history));
  }

  getPushRules = (pushSettings) => {
    const pushRules = [];
    if (pushSettings) {
      pushRules.push(pushSettings);
    }
    if (localStorage.getItem('soapLog')) {
      pushRules.push('soapLog')
    }
    if (localStorage.getItem('gamDirect')) {
      pushRules.push('gamDirect')
    }
    if (localStorage.getItem('forceStart')) {
      pushRules.push('forceStart')
    }
    return pushRules;
  };

  setPushData = (selected, type) => {
    const pids = selected.map(pl => pl.id);
    // console.log('Package setPushData', type, pids);
    if (type === 'packages') {
      this.setState({ selectedPackages: pids }, () => {
        return pids;
      });
    } else {
      this.setState({ selectedPlacements: pids }, () => {
        return pids;
      });
    }
  }

  render() {
    const {
      order,
      match,
      user,
      editList,
      constants,
      currentPackage,
      whitelist,
      error,
      ...rest
    } = this.props;
    const { pkgId, pkgOrder, dateRun } = this.state;
    const fetching = !pkgOrder && !error;

    return (
      <div>
        {fetching && <Spinner />}
        {error && !pkgOrder && (
          <ErrorPage error={error} entity="pack" />
        )}
        {!fetching && pkgOrder && (
          <div>
            <TrackingCtx.Provider value={{category:"Package", action:"Package Page", label:`Package#${pkgId}` }}>
            <PackagePage
              ioId={pkgOrder ? pkgOrder.IoId : 2044}
              order={order}
              pkg={pkgOrder ? pkgOrder.Packages[0] : []}
              pkgId={pkgId}
              pkgOrder={pkgOrder}
              dateRun={dateRun}
              user={user}
              constants={constants}
              onBack={this.redirectToIo}
              onSave={this.savePackage}
              onDelete={this.deletePackage}
              canDelete={this.canDelete}
              onClone={this.clone}
              onChange={this.onChange}
              onPushPackage={this.pushPackage}
              setPushData={this.setPushData}
              pushPlacementsFromPackage={this.pushPlacementsFromPackage}
              onValidationError={this.validationError}
              isReadOnly={isReadOnly({ role: user.roleName })}
              whitelist={whitelist}
              error={error}
              {...rest}
            />
            </TrackingCtx.Provider>
          </div>
        )}
      </div>
    )
  }
}

Package.defaultProps = {
  pack: null,
  order: null
};

Package.propTypes = {
  pack: PropTypes.object,
  order: PropTypes.object
};

const mapStateToProps = state => {
  const {
    orderRequest,
    constantRequest,
    user
  } = state;

  return {
    order: orderRequest.order,
    constants: constantRequest.constants,
    error: orderRequest.error || (state.packageRequest && state.packageRequest.error),
    user
  }
};

export default connect(mapStateToProps)(Package);
